import React from "react";
import { useNavigate } from "react-router-dom";
//import school from "../assets/school.jpg";
import faculty from "../assets/facility.jpg";
import history from"../assets/school.jpg";

const HomeAbout = () => {
  const navigate = useNavigate();

  return (
    <div className="home-about">

      <div className="home-about-overlay">

        <div className="container">

          <h2>
            ABOUT <span>NAV JEVAN MISSION SCHOOL</span>
          </h2>

          <p>In Kushinagar, during the year 1990, & Mrs. H.P. Sam realised the need of an english medium school 
            in Kushinagar distt. These great people, our Founders, established a school at Sapaha Road Kasia....
          </p>

          {/* MAIN BUTTON */}
          <button onClick={() => navigate("/about")}>
            READ MORE
          </button>

          {/* CARDS */}
          <div className="about-cards">

            <div
              className="about-card"
              onClick={() => navigate("/about?tab=history")}
            >

              <img src={history} alt="history" />

              <div>
                <h3>Origin & History</h3>
                <button>READ MORE</button>
              </div>

            </div>

            <div
              className="about-card"
              onClick={() => navigate("/about?tab=faculty")}
            >

              <img src={faculty} alt="faculty" />

              <div>
                <h3>FACULTY & STAFFS</h3>
                <button>READ MORE</button>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default HomeAbout;